
// File: src/pages/Staff/LeaveApprovalPage.jsx

import React from 'react';
import LeaveApprovalPanel from '@/components/Staff/LeaveApprovalPanel';

const LeaveApprovalPage = () => {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold text-white mb-4">✅ Approve Leave Requests</h1>
      <LeaveApprovalPanel />
    </div>
  );
};

export default LeaveApprovalPage;